var map = {
	"./bookmark.svg": "4e1b",
	"./bron.svg": "a2e7",
	"./calendar.svg": "557c",
	"./clock.svg": "4ccf",
	"./comefrotreat.part(12) 1.svg": "52ef",
	"./globus.svg": "170d",
	"./hide.svg": "8120",
	"./home.svg": "4b8a",
	"./inst.svg": "6e63",
	"./place.svg": "9a88",
	"./price.svg": "34eb",
	"./right-arrow.svg": "011b",
	"./search.svg": "0930",
	"./show.svg": "75f6",
	"./user.svg": "7393",
	"./vk.svg": "e7ae",
	"./youtube.svg": "400a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "65a8";